import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const KitchenwareIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "KitchenwareIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.0644 10.5802H4.73583C3.77573 10.5802 2.99463 11.3613 2.99463 12.3214C2.99463 13.7228 3.99323 14.8953 5.31623 15.165V19.3636C5.31623 20.9637 6.61807 22.2656 8.21823 22.2656H17.582C19.1822 22.2656 20.484 20.9637 20.484 19.3636V15.1649C21.807 14.8953 22.8056 13.7228 22.8056 12.3213C22.8056 11.3613 22.0245 10.5802 21.0644 10.5802ZM4.15543 12.3214C4.15543 12.0013 4.4158 11.741 4.73583 11.741H5.31623V13.9627C4.64068 13.7231 4.15543 13.078 4.15543 12.3214ZM19.3232 19.3636C19.3232 20.3237 18.5421 21.1048 17.582 21.1048H8.21823C7.25813 21.1048 6.47703 20.3237 6.47703 19.3636V11.741H19.3232V19.3636ZM20.484 13.9627V11.7409H21.0644C21.3844 11.7409 21.6448 12.0013 21.6448 12.3213C21.6448 13.078 21.1595 13.7231 20.484 13.9627Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0856 5.55608C19.0856 5.23554 18.8257 4.97568 18.5052 4.97568C18.3966 4.97568 17.4277 4.99197 16.8636 5.55608C16.2995 6.12019 16.2832 7.08907 16.2832 7.19772C16.2832 7.40009 16.2127 7.84866 16.0428 8.01852C15.8821 8.17929 15.4566 8.25703 15.222 8.25892C14.9015 8.25892 14.6416 8.51878 14.6416 8.83932C14.6416 9.15986 14.9015 9.41972 15.222 9.41972C15.3306 9.41972 16.2995 9.40343 16.8636 8.83932C17.4277 8.27521 17.444 7.30633 17.444 7.19996C17.4459 6.96304 17.5237 6.53765 17.6844 6.37687C17.8451 6.21618 18.2703 6.13844 18.5073 6.13647C18.8268 6.13539 19.0856 5.87596 19.0856 5.55608Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.7044 9.41973C18.813 9.41973 19.7819 9.40344 20.346 8.83933C20.9101 8.27522 20.9264 7.30634 20.9264 7.19997C20.9283 6.96305 21.0061 6.53766 21.1668 6.37688C21.3275 6.21619 21.7526 6.13845 21.9896 6.13648C22.3092 6.1354 22.568 5.87596 22.568 5.55608C22.568 5.23554 22.3082 4.97568 21.9876 4.97568C21.879 4.97568 20.9101 4.99197 20.346 5.55608C19.7819 6.12019 19.7656 7.08907 19.7656 7.19772C19.7656 7.40009 19.6951 7.84866 19.5252 8.01852C19.3645 8.17929 18.9391 8.25703 18.7044 8.25892C18.3839 8.25892 18.124 8.51878 18.124 8.83932C18.124 9.15986 18.3839 9.41973 18.7044 9.41973Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.40796 9.08071C5.54137 9.37161 5.88567 9.50011 6.17749 9.36627L18.8307 3.56227C19.1221 3.42862 19.2499 3.0841 19.1163 2.79274C18.9826 2.50138 18.6381 2.37354 18.3468 2.50718L14.1336 4.43972L14.1283 4.42823C13.593 3.26542 12.2114 2.75486 11.0486 3.29018C9.88576 3.8255 9.37524 5.20705 9.91056 6.36986L9.91319 6.37563L5.69353 8.31119C5.40217 8.44484 5.27432 8.78935 5.40796 9.08071ZM10.965 5.88445C10.6973 5.30304 10.9526 4.61225 11.534 4.34461C12.1154 4.07697 12.8062 4.33223 13.0738 4.91363L13.0785 4.92369L10.9683 5.89164L10.965 5.88445Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default KitchenwareIcon;
